import { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useGetUserInfo } from "../hooks/useGetUserInfo";
import { AuthData } from "../auth/AuthWrapper";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

import { DialogActions, IconButton } from "@mui/material";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import Button from "./General/Button";

//icon
import { IoIosNotifications } from "react-icons/io";
import { IoIosSettings } from "react-icons/io";
import { IoIosPerson } from "react-icons/io";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { IoMdClose } from "react-icons/io";
import CloseIcon from "@mui/icons-material/Close";
import { FaHome } from "react-icons/fa";

import { GiHamburgerMenu } from "react-icons/gi";
import SearchBar from "./SearchBar";
import { SideMenuContext } from "../context/SideMenuContext";
import SideMenu from "./SideMenu";
import { nav } from "./Navigation/navigation";
import { isRouteAllowed, isSuperAdmin, isActiveUser } from "../utils/authz";
import Shadow from "./General/Shadow";

function NavBar() {
  const location = useLocation();
  const sideMenuContext = useContext(SideMenuContext);
  const [toggled, setToggled] = useState(false);
  const { name, profilePhoto } = useGetUserInfo();
  const [logout, setLogout] = useState(false);
  // Бүх hook-уудыг үргэлж дээд талд дуудаж, дараа нь эрт буцах нөхцөлүүдийг хэрэглэнэ
  const { user, userProfile, useFirebaseSignOut } = AuthData();
  const { signOutUser } = useFirebaseSignOut();

  // Зөвхөн login хуудас дээр NavBar нуух
  if (location.pathname === "/" && !user?.isAuthenticated) {
    return null;
  }

  // const MenuItem = ({ r }) => {
  //     return (
  //         <div className="menuItem"><Link to={r.path} onClick={sideMenuContext.closeMenu}>{r.name}</Link></div>
  //     )
  // }

  const onSigningOut = () => {
    setLogout(true);
  };
  const onClose = () => {
    setLogout(false);
  };
  const onSignOut = () => {
    setLogout(false);
    signOutUser();
  };

  const isMenuAllowed = (path) => {
    if (!user?.isAuthenticated) return false;
    if (!userProfile) return false;
    if (!isActiveUser(userProfile) && !isSuperAdmin(userProfile)) return false;
    if (isSuperAdmin(userProfile)) return true;
    if (path === "/home") return true;
    return isRouteAllowed(userProfile, path);
  };

  return (
    <nav className="sticky top-0 left-0 z-50 bg-blue-500 flex justify-between items-center h-10 px-2">
      {toggled && <Shadow onClick={() => setToggled(false)} />}
      <div>
        <Sidebar
          toggled={toggled}
          breakPoint="all"
          backgroundColor="#FFFFFF"
          width="264px"
          rootStyles={{
            zIndex: 50,
            borderRight: "1px solid #F3F4F6",
            boxShadow:
              "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
          }}
        >
          <div className="flex flex-col h-full justify-between">
            <div className="flex-shrink-0">
              <div className="flex h-12 px-3 justify-between border-b items-center bg-gradient-to-r from-blue-50 to-indigo-50">
                <div className="font-semibold text-gray-700">Menu</div>
                <IconButton onClick={() => setToggled(false)}>
                  <IoMdClose />
                </IconButton>
              </div>
            </div>
            <div className="flex-1 min-h-0 overflow-y-auto">
              <Menu
                menuItemStyles={{
                  button: ({ level, active }) => ({
                    padding: "2px 10px",
                    paddingLeft: level > 0 ? 24 : 10, // Дэд цэсийг бага зэрэг баруун тийш шахах
                    margin: "1px 6px",
                    minHeight: "28px",
                    lineHeight: 1.15,
                    borderRadius: "6px",
                    color: active ? "#111827" : "#374151",
                    backgroundColor: active ? "#EEF2FF" : undefined,
                  }),
                  label: {
                    lineHeight: 1.15,
                  },
                  icon: {
                    color: "#6B7280",
                  },
                }}
              >
                <MenuItem
                  component={<Link to="/home" />}
                  icon={<FaHome />}
                  active={location.pathname === "/home"}
                  onClick={() => setToggled(false)}
                >
                  Нүүр
                </MenuItem>
                {(() => {
                  const items = nav.filter(
                    (r) => r.isMenu && isMenuAllowed(r.path)
                  );
                  
                  // Бүх цэсүүдийг parent болон child-уудаар ангилах
                  const parents = {};
                  const children = [];
                  const standalone = [];
                  
                  items.forEach((item) => {
                    if (item.isParent) {
                      parents[item.code] = { ...item, _children: [] };
                    } else if (item.parent) {
                      children.push(item);
                    } else {
                      standalone.push(item);
                    }
                  });
                  
                  // Дэд цэсүүдийг parent-тай холбох
                  children.forEach((child) => {
                    const parentKey = child.parent;
                    if (parents[parentKey]) {
                      parents[parentKey]._children.push(child);
                    } else {
                      // Parent олдоогүй бол standalone болгох
                      standalone.push(child);
                    }
                  });
                  
                  // Бүх цэсүүдийг нэгтгэх
                  const allItems = [
                    ...Object.values(parents),
                    ...standalone
                  ].sort((a, b) => (a.menuOrder || 0) - (b.menuOrder || 0));

                  return allItems.map((item) => {
                    if (item._children && item._children.length > 0) {
                      // Parent цэс (жишээ: Хүргэлт, Бараа, гэх мэт)
                      return (
                        <SubMenu key={item.code} label={item.name} icon={item.icon}>
                          {item._children
                            .sort((a, b) => (a.menuOrder || 0) - (b.menuOrder || 0))
                            .map((child) => (
                              <MenuItem
                                key={child.path}
                                component={<Link to={child.path} />}
                                icon={child.icon}
                                active={location.pathname === child.path}
                                onClick={() => setToggled(false)}
                              >
                                {child.name}
                              </MenuItem>
                            ))}
                        </SubMenu>
                      );
                    }
                    // Энгийн цэс
                    return (
                      <MenuItem
                        key={item.path}
                        component={<Link to={item.path} />}
                        icon={item.icon}
                        active={location.pathname === item.path}
                        onClick={() => setToggled(false)}
                      >
                        {item.name}
                      </MenuItem>
                    );
                  });
                })()}
              </Menu>
            </div>
            <div className="border-t flex p-3 justify-between items-center bottom-0 bg-white/60 flex-shrink-0">
              <div className="flex">
                <img
                  src={profilePhoto}
                  alt=""
                  className="w-8 h-8 rounded-full ring-2 ring-white"
                />
                <div className="font-medium pl-2 text-gray-800">{name}</div>
              </div>
              <div
                className={`
                            cursor-pointer p-2 rounded-md hover:bg-gray-100 text-gray-700
                            `}
                onClick={onSigningOut}
              >
                <RiLogoutBoxRLine />
              </div>
            </div>
          </div>
        </Sidebar>
      </div>

      <div className="container mx-auto flex justify-between px-2 items-center">
        {/* <div className="cursor-pointer px-2" onClick={sideMenuContext.toggleMenu}><GiHamburgerMenu /></div> */}
        <div
          className="cursor-pointer px-2"
          onClick={() => setToggled(!toggled)}
        >
          <GiHamburgerMenu />
        </div>
        <Link
          to="/home"
          aria-label="Нүүр хуудас"
          className="flex items-center gap-2 px-2 focus:outline-none rounded"
          tabIndex={0}
        >
          <img src="/logo192.png" alt="MyTools" className="h-6 w-auto" />
          <span className="hidden sm:inline font-semibold text-white">
            MyTools
          </span>
        </Link>
        <div className="flex-1 max-w-[520px]">
          <SearchBar />
        </div>
        <div className="hidden sm:block text-white">
          <IconButton>
            <IoIosNotifications className="text-gray-100" />
          </IconButton>
          <IconButton>
            <IoIosSettings className="text-gray-100" />
          </IconButton>
          <IconButton>
            <IoIosPerson className="text-gray-100" />
          </IconButton>
        </div>
      </div>

      <div className="">
        {sideMenuContext.isOpen && (
          <SideMenu>
            {nav.map((r, i) => (
              <MenuItem key={i} r={r} />
            ))}
          </SideMenu>
        )}
      </div>

      <Dialog
        open={logout}
        onClose={onClose}
        sx={{
          "& .MuiDialog-paper": {
            // Targeting the Dialog's paper component
            backgroundColor: "#f3f3f4", // Change to your desired color
          },
        }}
      >
        <DialogTitle>
          Та гарахдаа итгэлтэй байна уу?
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions>
          <Button text="Үгүй" onClick={() => onClose()}></Button>
          <Button text="Гарах" onClick={() => onSignOut()}>
            Устгах
          </Button>
        </DialogActions>
      </Dialog>
    </nav>
  );
}

export default NavBar;
